import { authedApiFetch } from '../utils/Api';

/**
 * Service for handling 'user' record API calls
 */
const userService = {
	/**
	 * Update user attributes
	 * @param {string} userId - The user ID
	 * @param {object} keyValues - User key value pair, ex: { ms_auto_sync: true }, { ms_auto_sync_start: '2025-08-26T09:49:22' }
	 * @returns {Promise<Object>} - Updated user data
	 */
	updateUser: async (userId, keyValue) => {
		const response = await authedApiFetch({
			endpoint: `/users/${userId}`,
			method: 'PATCH',
			payload: {
				user: keyValue,
			},
		});
		return response;
	},
};

export default userService;
